import React from "react";
import "../styles/FeaturesSection.css";
import {
  FiBarChart2,
  FiTrendingUp,
  FiCalendar,
  FiShield,
} from "react-icons/fi";

const features = [
  {
    icon: <FiBarChart2 />,
    title: "Smart Analytics",
    value: "$59,158",
    label: "Total Savings",
    accent: "green",
  },
  {
    icon: <FiTrendingUp />,
    title: "Expense Tracking",
    value: "2,984",
    label: "Transactions",
    accent: "blue",
  },
  {
    icon: <FiCalendar />,
    title: "Budget Planning",
    value: "698",
    label: "Monthly Goals",
    accent: "purple",
  },
  {
    icon: <FiShield />,
    title: "Secure Insights",
    value: "$658",
    label: "Protected Assets",
    accent: "orange",
  },
];

const FeaturesSection = () => {
  return (
    <section className="features-section">
      {/* Header */}
      <div className="features-header">
        <h2>Key Features</h2>
        <p>Simple steps to transform how you manage money</p>
      </div>

      {/* Stacked cards */}
      <div className="features-stack">
        <div className="stack-card back" />
        <div className="stack-card mid" />

        <div className="stack-card front">
          <div className="dashboard-left">
            <span className="badge">Mango</span>
            <h3>Personal Finance Dashboard</h3>
            <p>
              Get clear insights into your spending, savings, and goals through
              an intuitive dashboard built for everyday use.
            </p>
          </div>

          <div className="dashboard-right">
            {features.map((item, index) => (
              <div key={index} className={`metric-card ${item.accent}`}>
                <div className="metric-icon">{item.icon}</div>
                <div className="metric-info">
                  <span className="metric-label">{item.label}</span>
                  <strong className="metric-value">{item.value}</strong>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
